const updateValidation = (form) => {
        form.each(field => { // each loops through nested
            if (!document.getElementsByName(field.name).length) {
                field.resetValidation();
                return true;
            }
        });
    },

    /**
     * update validator with better validation messages.
     */
    validationExtension = ({ validator, form }) => {
        const messages = validator.getMessages('en');
        messages.required = 'Please complete this question.';
        messages.required_if = 'Please complete this question.';
        messages.required_with = 'Please complete this question.';
        messages.required_without = 'Please complete this question.';
        messages.required_without_all = 'Please complete this question.';
        validator.setMessages('en', messages);

        validator.register(
            'required',
            function(val, req, attribute) {
                updateValidation(form);

                if (val === undefined || val === null) {
                    return false;
                }

                const str = String(val).replace(/\s/g, '');
                return str.length > 0;
            },
            'Please complete this question.'
        );

        validator.register(
            'min',
            function(val, req, attribute) {
                // updateValidation(form);

                return this.getSize() >= req;
            },
            {
                numeric: 'This answer must be at least :min.',
                string: 'This answer must be at least :min characters.'
            }
        );

        validator.register(
            'greaterthan',
            function(val, req, attribute) {
                // updateValidation(form);

                return this.getSize() > req;
            },
            {
                numeric: 'This answer must be greater than :greaterthan.',
                string: 'This answer must be at least :greaterthan characters.'
            }
        );
    },

    rvalueRules = {
        wall: 'required|numeric|min:0|max:10',
        floor: 'required|numeric|min:0|max:10',
        ceiling: 'required|numeric|min:0|max:10',
        glazing: 'required|numeric|min:0|max:1.5'
    },

    percentageRule = 'required|numeric|min:0|max:100',

    formInvalidMessage = "OOPS: It looks like you haven't completed all of the questions above marked in red.<br />You'll need to complete these before you can progress.",

    rValue2009StandardsWarning = 'If you reduce the R-value or reduce the coverage of insulation it may mean you do not meet the 2009 insulation and glazing standard. Check you have answered the previous questions correctly.',

    glazing2009StandardsWarning = 'If you reduce the glazing it may mean you no longer meet the 2009 insulation and glazing standard. Check you have answered the previous questions correctly.';

export {
    validationExtension,
    rvalueRules,
    percentageRule,
    formInvalidMessage,
    rValue2009StandardsWarning,
    glazing2009StandardsWarning
};
